<script>
import BasePopup from '@/components/BasePopup.vue';

export default {
  name: 'StageSortChangePopup',
  controller: null,
  components: { BasePopup },
  props: {
    stages: Array,
  },
  data() {
    return {
      isOpened: false,
    };
  },
  methods: {
    sortByName(isAsc) { this.sort((a, b) => a.name.localeCompare(b.name), isAsc); },
    sortById(isAsc) { this.sort((a, b) => a.id - b.id, isAsc); },
    sort(sorter, isAsc) {
      const result = [...this.stages].sort((a, b) => sorter(a, b) * (isAsc ? 1 : -1));
      this.resolve(result);
    },
    open() {
      this.isOpened = true;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close() {
      this.isOpened = false;
      this.$options.controller.resolve(null);
    },
    resolve(result) {
      this.isOpened = false;
      this.$options.controller.resolve(result);
    },
  },
};
</script>

<template lang="pug">
  BasePopup(@close="close(false)" v-if="isOpened")
    .b-task-sort-change-popup
      ._warn Вы собираетесь пересортировать разделы. Это действие невозможно отменить.
      ._buttons
        Btn(green @click="sortByName(true)") По алфавиту по возрастанию
        Btn(green @click="sortByName(false)") По алфавиту по убыванию
        Btn(green @click="sortById(true)") По дате создания по возрастанию
        Btn(green @click="sortById(false)") По дате создания по убыванию
</template>

<style scoped lang="scss">
.task-sort-change-popup {
  &__warn {
    text-align: center;
    margin-bottom: 30px;
  }

  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 20px;
    column-gap: 10px;
  }

  @media (max-width: 992px) {
    &__buttons {
      grid-template-columns: 1fr;
    }
  }
}
</style>
